var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVariable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1096",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    width: 26,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,11A1,1,0,0,1,1,9C3.4,9,3.5,7.989,3.5,5.5,3.5,3.31,3.5,0,8,0A1,1,0,0,1,8,2C5.6,2,5.5,3.011,5.5,5.5,5.5,7.69,5.5,11,1,11",
    fill: "#202659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,20c-4.5,0-4.5-3.31-4.5-5.5C3.5,12.011,3.4,11,1,11A1,1,0,0,1,1,9c4.5,0,4.5,3.31,4.5,5.5,0,2.489.1,3.5,2.5,3.5a1,1,0,0,1,0,2",
    fill: "#202659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,11c-4.5,0-4.5-3.31-4.5-5.5C20.5,3.011,20.4,2,18,2a1,1,0,0,1,0-2c4.5,0,4.5,3.31,4.5,5.5,0,2.489.1,3.5,2.5,3.5a1,1,0,0,1,0,2",
    fill: "#202659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,20a1,1,0,0,1,0-2c2.4,0,2.5-1.011,2.5-3.5,0-2.19,0-5.5,4.5-5.5a1,1,0,0,1,0,2c-2.4,0-2.5,1.011-2.5,3.5,0,2.19,0,5.5-4.5,5.5",
    fill: "#202659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,14a1,1,0,0,1-1-1V7a1,1,0,0,1,2,0v6a1,1,0,0,1-1,1",
    fill: "#202659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,11H10a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2",
    fill: "#202659"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariable);
export default __webpack_public_path__ + "static/media/variable.5ec7aa2ffb36bc5249b8f3841a2f8b1a.svg";
export { ForwardRef as ReactComponent };